import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CustomColumnConditionCellRendererParams } from '@ddv/data-grid';
import { AUTO_GROUP_COLUMN_ID } from '@ddv/models';

@Component({
    selector: 'app-column-condition-cell-renderer',
    templateUrl: './column-condition-cell-renderer.component.html',
    styleUrls: ['./column-condition-cell-renderer.component.scss'],
    standalone: false,
})
export class ColumnConditionCellRendererComponent implements ICellRendererAngularComp {
    cellInnerHTML: SafeHtml | undefined;

    private params: CustomColumnConditionCellRendererParams | undefined;

    constructor(private readonly domSanitizer: DomSanitizer) {
    }

    agInit(params: CustomColumnConditionCellRendererParams): void {
        this.params = params;
        this.setup();
    }

    refresh(params: CustomColumnConditionCellRendererParams): boolean {
        this.params = params;
        this.setup();
        return true;
    }

    private setup(): void {
        if (!this.params) {
            return;
        }

        let valueToSanitize: string;
        if (this.params.displayType === 'bar') {
            valueToSanitize = this.params.valueFormatted as string;
        } else {
            valueToSanitize = this.params.colDef?.colId === AUTO_GROUP_COLUMN_ID ?
                this.params.value as string :
                this.params.valueFormatted as string;
        }

        this.cellInnerHTML = this.domSanitizer.bypassSecurityTrustHtml(valueToSanitize);
    }
}
